module.exports = __webpack_public_path__ + "static/media/sch-1.50de8d83.jpg";